import React from 'react';
import { CheckCircle, ShieldCheck, Leaf, Trophy } from 'lucide-react';

interface ValueProps {
  icon: React.ReactNode;
  title: string;
}

const Value: React.FC<ValueProps> = ({ icon, title }) => {
  return (
    <div className="flex items-center">
      <div className="text-primary mr-2">
        {icon}
      </div>
      <span className="font-medium">{title}</span>
    </div>
  );
};

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">About ECORIDE</h2>
            <p className="text-gray-600 mb-6">
              Founded in 2018, ECORIDE is dedicated to transforming urban mobility through innovative electric bicycle technology. 
              Our mission is to create sustainable, efficient, and enjoyable transportation solutions that reduce traffic congestion 
              and carbon emissions while enhancing the daily lives of our riders.
            </p>
            <p className="text-gray-600 mb-6">
              Our team of engineers, designers, and cycling enthusiasts combines cutting-edge technology with rider-focused design
              to create electric bicycles that exceed expectations in performance, reliability, and style.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Value 
                icon={<CheckCircle size={20} />}
                title="German Engineering Standards"
              />
              <Value 
                icon={<ShieldCheck size={20} />}
                title="5-Year Warranty"
              />
              <Value 
                icon={<Leaf size={20} />}
                title="Sustainable Manufacturing"
              />
              <Value 
                icon={<Trophy size={20} />}
                title="Award-Winning Designs"
              />
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary rounded-full opacity-20"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-accent rounded-full opacity-20"></div>
            <img 
              src="https://images.pexels.com/photos/13401344/pexels-photo-13401344.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
              alt="ECORIDE workshop" 
              className="w-full h-auto rounded-lg shadow-xl relative z-10 object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;